import {useVideoTexture} from '@react-three/drei'
import {useControls} from 'leva'
import {
    useEffect,
    useMemo,
    useRef
} from 'react'

export function useComputerScreenTexture() {
    const videoSettings = useMemo(() => ({
        unsuspend: 'canplay', // Start playing when enough data is loaded
        muted: true,          // Muted video
        loop: true,           // Loop the video
        start: true,          // Auto-start
        crossOrigin: 'Anonymous', // Allow cross-origin videos
        playsInline: true     // Important for mobile
    }), [])

    const {
        selectedVideo,
        // isPaused,
        // colorSpace,
    } = useControls('Computer Screen', {
        selectedVideo: {
            value: 'blender',
            options: ['blender', 'programming', 'game']
        },
        // isPaused: false,
        /*colorSpace: {
            value: THREE.SRGBColorSpace,
            options: [THREE.SRGBColorSpace, THREE.LinearSRGBColorSpace, THREE.NoColorSpace]
        }*/
    })

    // const videoPath = `./videos/${selectedVideo}.mp4`
    const videoRef = useRef(null)

    // Video texture creation and management
    const blenderVideoTexture = useVideoTexture('./videos/blender.mp4', videoSettings)
    const programmingVideoTexture = useVideoTexture('./videos/programming.mp4', videoSettings)
    const gameVideoTexture = useVideoTexture('./videos/game.mp4', videoSettings)

    const videoTextures = {
        blender: blenderVideoTexture,
        programming: programmingVideoTexture,
        game: gameVideoTexture,
    }

    const videoTexture = videoTextures[selectedVideo]

    useEffect(() => {
        if (videoRef.current) videoRef.current.pause()
        if (videoTexture) {
            videoRef.current = videoTexture.source.data
            videoRef.current.currentTime = 0
            videoRef.current.play()
        }
    }, [videoTexture])


    /*useEffect(() => {
        if (videoTextures[selectedVideo]) {
            videoRef.current = videoTextures[selectedVideo].source.data
        }
    }, [])

    // Texture settings
    useEffect(() => {
        // for (const videoTexturesKey in videoTextures) {
        //     videoTextures[videoTexturesKey].colorSpace = colorSpace
        //     videoTextures[videoTexturesKey].pause()
        // }
        // console.log('change colorspace to', THREE.SRGBColorSpace)
        if (videoRef.current) {
            videoRef.current.pause()
        }

    }, [selectedVideo])*/


    // return [videoTextures[selectedVideo], videoRef]
    return [videoTexture, videoRef]
}
